const commision = {
  root: "commission",
  root_plural: "commissions",
};
export default commision;
